import axios from 'axios';

const API_URL = '/api/calendar';

export interface CalendarHoliday {
    date: string;
    name: string;
}

export const getCalendarHolidays = async (year: number, month: number) => {
    const response = await axios.get(`${API_URL}/holidays`, { params: { year, month } });
    return response.data as CalendarHoliday[];
};
